import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout,
  headers: API_CONFIG.headers,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const chartService = {
  getOverview: async (patientId) => {
    const response = await api.get(`/chart/patients/${patientId}/overview`);
    return response.data;
  },

  createFact: async (patientId, data) => {
    const response = await api.post(`/chart/patients/${patientId}/facts`, data);
    return response.data;
  },

  verifyFact: async (factId) => {
    const response = await api.patch(`/chart/facts/${factId}/verify`);
    return response.data;
  },

  deactivateFact: async (factId) => {
    const response = await api.patch(`/chart/facts/${factId}/deactivate`);
    return response.data;
  },
};

export default chartService;
